import React from "react";
import { useState } from "react";
// import { Button } from "react-bootstrap";
import AcceptInvitation from "./AcceptInvitation";
import RejectInvitation from "./RejectInvitation";
import BuilderAcceptInvitation from "./BuilderAcceptInvitation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faXmarkCircle,
} from "@fortawesome/free-solid-svg-icons";
import CustomTooltip from "../../../common/CustomTooltip";

const InvitationsActionButton = ({ id, handleInvitations, status }) => {
  const [showAcceptInvitation, setShowAcceptInvitation] = useState(false);
  const [showRejectInvitation, setShowRejectInvitation] = useState(false);
  const invitationStatus = parseInt(status);
  const roleType = localStorage.getItem("roleType");

  const toggleShowAcceptInvitationModal = () => {
    setShowAcceptInvitation(!showAcceptInvitation);
  };

  const toggleShowRejectInvitationModal = () => {
    setShowRejectInvitation(!showRejectInvitation);
  };

  return (
    <>
      <span>
        {invitationStatus === 1 || invitationStatus === 2 ? (
          <>-</>
        ) : (
          <>
            <CustomTooltip message={"Accept"}>
              <span>
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  size="1x"
                  onClick={toggleShowAcceptInvitationModal}
                />
              </span>
            </CustomTooltip>
            <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
            <CustomTooltip message={"Reject"}>
              <span>
                <FontAwesomeIcon
                  icon={faXmarkCircle}
                  size="1x"
                  onClick={toggleShowRejectInvitationModal}
                />{" "}
              </span>
            </CustomTooltip>
          </>
        )}
        {showAcceptInvitation &&
          (roleType === "Builder" ? (
            <BuilderAcceptInvitation
              id={id}
              handleInvitations={handleInvitations}
              showAcceptInvitation={showAcceptInvitation}
              toggleShowAcceptInvitationModal={toggleShowAcceptInvitationModal}
            />
          ) : (
            <AcceptInvitation
              id={id}
              handleInvitations={handleInvitations}
              showAcceptInvitation={showAcceptInvitation}
              toggleShowAcceptInvitationModal={toggleShowAcceptInvitationModal}
            />
          ))}
        {showRejectInvitation && (
          <RejectInvitation
            id={id}
            handleInvitations={handleInvitations}
            showRejectInvitation={showRejectInvitation}
            toggleShowRejectInvitationModal={toggleShowRejectInvitationModal}
          />
        )}
      </span>
    </>
  );
};

export default InvitationsActionButton;
